module.exports = __webpack_public_path__ + "img/2025-07-21a_7.45c78ecc.jpg";